import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { JobComponent } from './job.component';

import { HomeComponent } from './home/home.component';
import { DetailComponent } from './detail/detail.component';
import { CompanyComponent } from './company/company.component';
import { CanActivateAllRouter } from '../core/services/can-activate-guard';
const routes: Routes = [

  {
    path: '', component: JobComponent, canActivate: [CanActivateAllRouter], children: [
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'detail/:id', component: DetailComponent },
      { path: 'company/:id', component: CompanyComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobRoutingModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/job-routing.module.ts